import styled from 'styled-components';

const MyDiv = styled.div`
  /* Calendar Popup */
  .chakra-datepicker {
    width: 350px;
    // padding: 16px;
    z-index:999
  }

  /* Header with month/year dropdowns and navigation arrows */
  .chakra-datepicker .react-datepicker__header {
    background-color: #ecf2f5ff;
    border-bottom: none;
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* Month/Year selectors container */
 .chakra-datepicker .react-datepicker__current-month {
    display: none !important;
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
  }

  .chakra-datepicker .react-datepicker__header {
    padding-top: 12px; /* Adjust based on your spacing needs */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  /* Navigation arrows */
  .chakra-datepicker .react-datepicker__navigation {
    top: 12px;
    line-height: 1.2;
    border: none;
    background: transparent;
    font-size: 18px;
    color: #c9d0ddff; /* gray.700 */
    cursor: pointer;
  }

  .chakra-datepicker .react-datepicker__navigation--previous {
    left: 8px;
  }

  .chakra-datepicker .react-datepicker__navigation--next {
    right: 8px;
  }

  /* Month and year dropdowns */
  .chakra-datepicker select {
    border: 1px solid #cbd5e0;
    border-radius: 6px;
    padding:  4px 8px;
    background-color: #fff;
    color: #2d3748;
    font-family: 'Poppins', sans-serif;
    outline: none;
    cursor: pointer;
    font-size: 14px;
  }

  .chakra-datepicker select:focus {
    border-color: #059f58;
    box-shadow: 0 0 0 1px #059f58;
  }

 /* Weekday headers */
.chakra-datepicker .react-datepicker__day-name {
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    color: #718096;
    text-align: center;
    width: 2.5rem;          /* match day cell width */
    height: 2.5rem;         /* match day cell height */
    line-height: 2.5rem;    /* vertically center text */
    margin: 0;               /* remove default margin */
}

/* Days grid */
.chakra-datepicker__month {
    display: grid;
    grid-template-columns: repeat(7, 2.5rem); /* match day width */
    gap: 6px;
    margin-top: 4px;
}

/* Day cells */
.chakra-datepicker .react-datepicker__day {
    width: 2.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 8px;
    text-align: center;
    transition: background-color 0.2s;
    margin: 0;                /* remove default margin */
    box-sizing: border-box;   /* ensure padding doesn*

  .chakra-datepicker .react-datepicker__day--today {
    background-color: #d1fae5;
    font-weight: bold;
  }

  .chakra-datepicker .react-datepicker__day--selected,
  .chakra-datepicker .react-datepicker__day--in-range,
  .chakra-datepicker .react-datepicker__day--in-selecting-range {
    background-color: #059f58;
    color: white;
  }

  .chakra-datepicker .react-datepicker__day--disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export default MyDiv;
